/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxmAgentauthV1AgentKeyEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXM_AGENTAUTH_V1_AGENT_KEY_EVENT_ENTITY_NAME = 'ixm.agentauth.v1.AgentKeyEvent';
export const ixmAgentauthV1AgentKeyEventEntity = new schema.Entity<IxmAgentauthV1AgentKeyEvent>(IXM_AGENTAUTH_V1_AGENT_KEY_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxmAgentauthV1AgentKeyEvent) => `${entity.metadata?.eventId}` });

